import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

export const LitecoinTrading: React.FC = () => {

    return (
        <div className="bv-litecoin-trading-page page">
            <div className="breadcrumb-area">
                <div className="container h-100">
                    <div className="row h-100 align-items-center justify-content-center">
                        <div className="col-lg-5">
                            <div className="breadcrumb-title text-center">
                                <h2>Litecoin Trading</h2>
                                <ul className="breadcrumb-list">
                                    <li>Home</li>
                                    <li> <FontAwesomeIcon icon={icon({ name: 'angle-double-right', style: 'solid' })} /> </li>
                                    <li>Litecoin Trading</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="blog-details-area section-padding-100-50 bg-gray-cu">
        <div className="container">
            <div className="row">
                <div className="col-lg-12">
                    <div className="blog-details-content mb-50">
                        
 <h1 className="uk-margin-small-bottom">Litecoin Trading</h1>
                            <p className="uk-text-lead uk-text-muted uk-margin-remove-top">
				Litecoin has established itself as the leading competitor to Bitcoin, and now you can trade this exciting digital 
				currency with Marex Capital Markets.
</p>
Litecoin has established itself as the leading competitor to Bitcoin, and now you can trade this exciting digital currency with Marex Capital Markets.
 When you trade Litecoin with Marex Capital Markets you can trade long or short (buy or sell) instantly, so you can act on your analysis whether you’re 
 optimistic or cynical about the future of digital currencies.



 <p className="uk-text-lead uk-text-muted uk-margin-remove-top">
</p><ul className="uk-list uk-list-bullet in-list-check">
<li>Trade Litecoin with leverage Up to 20:1</li>
			<li>Trade on the powerful Meta Trader 4 platform</li>
			<li>Trade wherever you are with our free tablet and mobile apps</li>
			<li>Enjoy the security of trading with a regulated forex broker</li>
			<li>Get live support in your language whenever the markets are open</li>
			<li>The Litecoin market is available to traders 24/7, for maximum convenience</li>
			<li>Both manual and automated trading platforms available</li>
		</ul>		
				<p>Trade with the licensed and award-winning forex broker.
Open an account today and enjoy features and benefits that Marex Capital Markets has to offer.</p>
				<br /><br />
	
			
<h2>What is Litecoin?</h2>
<p>An open source internet currency that allows for instant, near zero cost peer-to-peer payments across the world. The Litecoin blockchain is capable of handling higher transaction volumes unlike its forefather the Bitcoin.</p>

<p>This would be fairly due to it’s a more frequent block generation where the network supports more transaction without a need to modify any future software. As a result, merchants gain faster payment confirmations.</p>

<h2>The Science of Litecoin</h2>
<p>Electronic mining of Litecoins currently allocates miners 50 new Litecoins per block, of which this amount is halved every 4 years or approximately every 840,000 blocks. The network for the Litecoin is set to produce 84 million Litecoins which sums up to 4 times the amount of bitcoin units.</p>

<p>The distribution of Litecoins is done by wallet encryption, that secures the safety of the coins as well as allows you to view your transactions.</p>

<h2>Why  make sense for Trading Litecoin:</h2>
<p>As  allow you to speculate on the price of Litecoin future market movements, without physically owning the coin. Traders whether buying or selling are able to agree to pay on the difference on the price even if it rises or falls. In addition, they can to tap into the benefits and risks without actually owning the coin and benefit from:</p>

<ul>
<li>Security – You don’t have to worry about your Litecoins being stolen. Your potential profits are based on the movement of the Litecoin price but no Litecoins are bought or sold in your name.</li>
<li>Simplicity – Buying cryptocurrencies directly can be complicated. With Marex Capital Markets trading it’s as easy as selecting Litecoin from a menu and clicking to sell or buy. It’s so simple you can do it on your mobile or tablet too.</li>
<li>Get leverage of up to 20:1 – As a financial derivative you can trade on leverage, meaning you can open a larger position in the market.</li>
<li>Diversify – As one of the world’s leading brokers Marex Capital Markets offers a wide range of products and Forex pairs for you to trade, all from a single platform.</li>
</ul>

<h2>Litecoin – Silver to Bitcoin’s Gold</h2>
<p>Litecoin is a peer-to-peer, decentralised digital currency (also known as a cryptocurrency) based on the Bitcoin system. The creators of Litecoin sought to adapt the Bitcoin model to develop a more stable and efficient currency.</p>

<p>There are several key differences between Bitcoin (and its spin-offs Bitcoin Cash and Bitcoin Gold) and Litecoin, including the way coins are “mined”, security procedures, and the total number of coins destined to be produced.</p>

<p>In 2013 Litecoin’s value rocketed from less than $0.01 to more than $20. Could Litecoin follow Bitcoin’s lead and keep on rising in value? With Marex Capital Markets you can enter and exit the markets, with our speedy execution and leveraged positions. Practice on our 21-day demo account and feel your way through trading Litecoins and getting to know your way around our platforms.</p>

<p>When trading with Marex Capital Markets you are trading on the price changes of the digital coin, and not physically purchasing it.</p>
<p>
The maximum accumulated position size for Litecoin is $200,000 notional value, details in our Conditions and Charges page.</p>       
                       

                    </div>
                </div>

                        
                    </div>
                </div>
            </div>
        </div>
    )
}